import { DownOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { Viewport } from 'components/ViewportProvider';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CartItem, ItemDiscount, ProductNoteInput, SingleSupplierCart } from 'types/schema';
import utilsMessages from 'utils/messages';
import CartItemDesktop from './CartItem/CartItemDesktop';
import CartItemMobile from './CartItem/CartItemMobile';
import ConfirmedCartItemMobile from './CartItem/ConfirmedCartItemMobile';
import ModalNote from './ProductNoteModal';
import media from 'utils/mediaStyle';
import messages from 'containers/CheckoutPage/messages';
import NotAvailableProductItem from './NotAvailableProductItem';

export type ProductsQuantityType = {
  [key: string]: number;
};

const OrderTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 8px;

  ${media.lg`
    margin: 0;
    gap: 1px;
  `}
`;

const AddMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 8px 0;

  ${media.lg`
    margin: 16px 0 0;
  `}
`;

const AddMoreButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 16px;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f9fafb;
    color: #111827;
  }
`;

const ShoppingBagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M11.7539 3.99642H2.24512V11.6675C2.24512 11.8454 2.31584 12.0162 2.44165 12.142C2.56746 12.2678 2.73826 12.3385 2.91618 12.3385H11.0828C11.2608 12.3385 11.4316 12.2678 11.5574 12.142C11.6832 12.0162 11.7539 11.8454 11.7539 11.6675V3.99642ZM5.16178 5.83415C5.16178 6.32148 5.35552 6.78895 5.70011 7.13355C6.04471 7.47814 6.51218 7.67188 6.99951 7.67188C7.48685 7.67188 7.95431 7.47814 8.29891 7.13355C8.64351 6.78895 8.83724 6.32148 8.83724 5.83415H9.82845C9.82845 6.58449 9.53073 7.30423 9.00016 7.8348C8.46959 8.36537 7.74985 8.66309 6.99951 8.66309C6.24917 8.66309 5.52943 8.36537 4.99886 7.8348C4.46829 7.30423 4.17057 6.58449 4.17057 5.83415H5.16178ZM2.74072 3.00521H11.2583L10.2517 1.66309H3.74731L2.74072 3.00521ZM12.7451 11.6675C12.7451 12.1084 12.5704 12.5315 12.2586 12.8433C11.9468 13.155 11.5238 13.3298 11.0828 13.3298H2.91618C2.47526 13.3298 2.05218 13.155 1.7404 12.8433C1.42862 12.5315 1.25391 12.1084 1.25391 11.6675V3.50081C1.25391 3.39353 1.28866 3.28928 1.35303 3.20345L3.10303 0.870117L3.14062 0.825684C3.23361 0.728031 3.36299 0.671875 3.49951 0.671875H10.4995C10.6556 0.671875 10.8024 0.745264 10.896 0.870117L12.646 3.20345C12.7104 3.28928 12.7451 3.39353 12.7451 3.50081V11.6675Z"
      fill="#4B5563"
    />
  </svg>
);

const FavoriteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11" fill="none">
    <path
      d="M11.8914 3.37283C11.779 0.533092 8.38402 -1.0269 6.34448 1.16171C6.2978 1.21164 6.04134 1.55048 6.01166 1.54269C5.225 0.451124 4.03119 -0.0727219 2.69099 0.221959C1.48046 0.487778 0.558375 1.48438 0.259273 2.67177C-0.402902 5.30081 1.6254 7.04003 3.37679 8.583C4.05194 9.17813 4.80257 9.86736 5.50595 10.4143C5.85721 10.6873 6.18974 10.7182 6.53984 10.4143C8.32581 8.66468 11.722 6.68532 11.9127 3.93939V3.40919L11.8914 3.37283ZM8.25493 8.03C7.52475 8.67478 6.76547 9.28838 6.03097 9.92825C6.00475 9.93287 5.93271 9.87111 5.90764 9.85062C4.99881 9.10829 4.03321 8.27186 3.16961 7.477C1.80982 6.22555 0.363872 4.78533 0.955161 2.74652C1.25657 1.70749 2.1144 0.92042 3.2114 0.835277C4.05078 0.76976 4.7461 1.11639 5.28725 1.73808C5.43593 1.90866 5.66876 2.34967 5.8454 2.42327C6.30932 2.61606 6.49662 2.04315 6.73665 1.76232C8.12699 0.137394 10.5094 0.742919 11.0906 2.74652C11.7577 5.04596 9.77925 6.68388 8.25493 8.03Z"
      fill="#4B5563"
    />
    <path
      d="M6.24885 1.07223C7.30899 -0.0652707 8.72742 -0.229971 9.89184 0.261034C11.0443 0.74708 11.9495 1.87611 12.0207 3.33322L12.0264 3.3429L12.0446 3.37366V3.94446L12.044 3.94902C11.945 5.37325 11.0164 6.58382 9.91576 7.64499C9.36366 8.17726 8.76225 8.67767 8.19026 9.15174C7.61648 9.62729 7.07397 10.0754 6.63223 10.5081L6.62654 10.5138C6.43389 10.681 6.23253 10.7669 6.02099 10.7622C5.812 10.7574 5.61404 10.6648 5.42569 10.5184C5.07188 10.2432 4.70588 9.93231 4.34447 9.61601L3.2906 8.68177C2.41844 7.9134 1.45916 7.08119 0.804597 6.10804C0.145898 5.12872 -0.209871 3.99885 0.132396 2.63994L0.197907 2.41208C0.562782 1.28359 1.47756 0.35452 2.6634 0.0941228C4.00756 -0.201363 5.20985 0.298176 6.0244 1.34453C6.03872 1.32756 6.05493 1.31005 6.07055 1.29098C6.1384 1.20809 6.22173 1.10124 6.24885 1.07223ZM9.78987 0.50314C8.75239 0.0656178 7.50122 0.191747 6.53368 1.1554L6.44083 1.25167C6.42127 1.27259 6.35334 1.3603 6.27392 1.45732C6.2369 1.50254 6.19849 1.54823 6.16682 1.58265C6.15142 1.59939 6.13456 1.61641 6.11897 1.62993C6.11159 1.63632 6.10014 1.64585 6.0865 1.65386C6.07972 1.65782 6.06848 1.66366 6.05403 1.6681C6.04068 1.67217 6.01255 1.67864 5.97883 1.66981L5.93326 1.65784L5.90535 1.61968C5.14648 0.566772 4.00411 0.0681569 2.7198 0.35047C1.56354 0.604373 0.675473 1.55926 0.387035 2.70431C0.0672085 3.97433 0.394522 5.02841 1.02221 5.96164C1.65407 6.90104 2.5846 7.71011 3.46378 8.48467C4.14206 9.08257 4.88775 9.76735 5.5869 10.311L5.70596 10.3936C5.82138 10.4637 5.9273 10.4973 6.02668 10.4996C6.15601 10.5025 6.29521 10.4524 6.45165 10.3173C6.90222 9.8763 7.45306 9.42227 8.02278 8.95008C8.59578 8.47517 9.19006 7.98087 9.73404 7.45643C10.8255 6.40416 11.6901 5.25227 11.782 3.93079V3.44544L11.7786 3.43974L11.762 3.41126L11.7609 3.37822C11.7068 2.01242 10.8637 0.956006 9.78987 0.50314ZM3.20173 0.7048C4.08905 0.635589 4.82269 1.00464 5.38638 1.65215L5.45303 1.73589C5.47559 1.76661 5.49819 1.79966 5.52082 1.83273C5.56812 1.90185 5.61477 1.97198 5.66381 2.0418C5.71234 2.1109 5.75864 2.17343 5.80224 2.22181C5.84837 2.27299 5.88017 2.29538 5.89623 2.30213L5.95889 2.32321C6.0172 2.33705 6.06374 2.33158 6.10302 2.31751C6.15976 2.29713 6.21661 2.25303 6.27676 2.18421C6.337 2.11527 6.39244 2.03102 6.45165 1.93983C6.50848 1.8523 6.57051 1.75542 6.63736 1.67721C8.10005 -0.03219 10.6084 0.61316 11.2169 2.71001C11.5647 3.90903 11.2194 4.93435 10.6028 5.82093C9.98998 6.70196 9.10009 7.45948 8.34236 8.12863C7.97598 8.45216 7.60211 8.76772 7.22924 9.08167C6.85615 9.3958 6.48393 9.70838 6.11783 10.0273L6.08992 10.0512L6.05403 10.0581C6.02337 10.0634 5.9977 10.0574 5.98396 10.0535C5.96869 10.0492 5.955 10.0436 5.94522 10.0387C5.92572 10.0289 5.9072 10.0165 5.89281 10.0062C5.86397 9.98565 5.83519 9.961 5.82502 9.95268C4.91423 9.20875 3.9465 8.37042 3.08096 7.57378C2.40221 6.9491 1.68682 6.26405 1.21817 5.47401C0.746151 4.67817 0.521972 3.77095 0.829662 2.71001C1.14449 1.62509 2.04389 0.794665 3.20173 0.7048ZM3.22224 0.966274H3.22167C2.18573 1.04679 1.36949 1.79056 1.08145 2.78349C0.797985 3.76108 1.00091 4.59346 1.44376 5.34013C1.89015 6.09267 2.57774 6.75395 3.2587 7.38066C4.12031 8.1737 5.08396 9.00861 5.99079 9.74931H5.99136C5.99854 9.75518 6.00709 9.76159 6.01586 9.76868C6.36138 9.46906 6.71176 9.17432 7.06062 8.88058C7.43347 8.56664 7.80489 8.25327 8.16861 7.93209C8.93518 7.25514 9.79673 6.52039 10.3874 5.67111C10.9742 4.82742 11.2842 3.88378 10.9651 2.78349C10.411 0.873387 8.15467 0.307803 6.83674 1.84811C6.78369 1.91021 6.73227 1.99016 6.67211 2.08281C6.6143 2.17184 6.54887 2.27161 6.47444 2.35682C6.39986 2.44213 6.30758 2.52311 6.19132 2.56474C6.08569 2.60256 5.97099 2.60407 5.84838 2.56417L5.7954 2.54481C5.7231 2.51468 5.65913 2.45465 5.60741 2.39726C5.55307 2.33696 5.49935 2.26437 5.44905 2.19276C5.39924 2.12185 5.34802 2.04523 5.30435 1.98141C5.25873 1.91474 5.22023 1.86092 5.18871 1.82475C4.6702 1.22908 4.01345 0.904595 3.22224 0.966274Z"
      fill="#4B5563"
    />
  </svg>
);

const OrderTableHeader = styled.div`
  padding: 16px 20px;
  background: #fff;
  display: grid;
  grid-template-columns: auto 140px 150px 120px;
  column-gap: 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  ${({ currentStep }) =>
    currentStep === 3 &&
    `
    grid-template-columns: auto 100px 150px 120px;
    `}
`;

const OrderTableHeaderTitle = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: #4b5563;
  font-weight: 500;
  text-align: ${({ textAlign }: { textAlign?: string }) => textAlign || 'left'};
  white-space: nowrap;
`;

const NotAvailableSectionWrapper = styled.div`
  background: #f2f3f5;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
  margin-top: 16px;
  width: 100%;
`;

const NotAvailableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #fff;
`;

const NotAvailableTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #111827;
  letter-spacing: -0.32px;
`;

const RemoveAllButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #e2483c;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const COLLAPSED_PRODUCT_COUNT = 5;

const ProductAccordionAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 12px 16px;
  background: #fff;
  cursor: pointer;
`;

const ProductAccordionText = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #4b5563;
`;

interface ICheckoutOrderTableProps {
  singleSupplierCart: SingleSupplierCart;
  name: string;
  onRemoveItem?: (cartItem: CartItem) => void;
  onRemoveAllNotAvailableItems?: (items: CartItem[]) => void;
  productsQuantity: ProductsQuantityType;
  setProductNote?: (data: ProductNoteInput) => void;
  noteItemLoading?: boolean;
  itemDiscount?: ItemDiscount[];
  currentStep: number;
  notAvailableProducts?: CartItem[];
}

const CheckoutOrderTable = (props: ICheckoutOrderTableProps) => {
  const {
    name,
    productsQuantity,
    onRemoveItem,
    onRemoveAllNotAvailableItems,
    singleSupplierCart,
    setProductNote,
    noteItemLoading,
    itemDiscount,
    currentStep,
    notAvailableProducts,
  } = props;
  const { supplier } = singleSupplierCart;
  const lang = localStorage.getItem('lang') || 'vi';

  const [isOpenNoteModal, setIsOpenNoteModal] = useState(false);
  const [previewProduct, setPreviewProduct] = useState<CartItem | null>(null);
  const [isProductListExpanded, setIsProductListExpanded] = useState(true);

  const onRemoveProductItem = useCallback(
    (item: CartItem) => {
      if (item?.product && onRemoveItem) {
        onRemoveItem({
          product: { ...item.product, supplier: supplier },
        });
      }
    },
    [supplier, onRemoveItem],
  );

  const onRemoveAllNotAvailable = useCallback(() => {
    if (!onRemoveAllNotAvailableItems || !notAvailableProducts?.length) return;

    onRemoveAllNotAvailableItems(notAvailableProducts);
  }, [notAvailableProducts, onRemoveAllNotAvailableItems]);

  const onCloseNote = useCallback(() => {
    setPreviewProduct(null);
    setIsOpenNoteModal(false);
  }, []);

  const onNoteSubmit = useCallback(
    (note) => {
      if (setProductNote) {
        setProductNote({
          note: note,
          productId: previewProduct?.product?.id || '',
        });
      }
      onCloseNote();
    },
    [setProductNote, previewProduct, onCloseNote],
  );

  if (!singleSupplierCart || !singleSupplierCart?.items) return null;
  const { items } = singleSupplierCart;

  const validItems = items?.filter((item) => item?.product && productsQuantity[item.product.id] !== 0) || [];

  const loggedIn = !!localStorage.getItem('token');

  return (
    <>
      <Viewport.Consumer>
        {({ width }) => {
          const isDesktop = width >= 1024;
          const showAccordion = !isDesktop && currentStep === 3 && validItems.length > COLLAPSED_PRODUCT_COUNT;
          const visibleItems =
            showAccordion && !isProductListExpanded ? validItems.slice(0, COLLAPSED_PRODUCT_COUNT) : validItems;
          return (
            <OrderTableWrapper currentStep={currentStep}>
              {isDesktop && (
                <OrderTableHeader currentStep={currentStep}>
                  <OrderTableHeaderTitle>
                    <FormattedMessage {...utilsMessages.Product} />
                  </OrderTableHeaderTitle>
                  <OrderTableHeaderTitle>
                    <FormattedMessage {...utilsMessages.quantity} />
                  </OrderTableHeaderTitle>
                  <OrderTableHeaderTitle textAlign="right">
                    <FormattedMessage {...utilsMessages.subtotalExclVat} />
                  </OrderTableHeaderTitle>
                  <OrderTableHeaderTitle textAlign="right">
                    <FormattedMessage {...utilsMessages.totalInclVat} />
                  </OrderTableHeaderTitle>
                </OrderTableHeader>
              )}
              {visibleItems.map((item, index) => {
                const itemDiscountBeforeVat =
                  itemDiscount?.find((it) => it?.id === item?.product?.id)?.discountValue || 0;
                const isLastItem = index === visibleItems.length - 1 && !showAccordion;

                return isDesktop ? (
                  <CartItemDesktop
                    key={`${name}-${item?.product?.id}`}
                    cartItem={item}
                    lang={lang}
                    onRemoveProduct={onRemoveProductItem}
                    openNote={() => {
                      setPreviewProduct(item);
                      setIsOpenNoteModal(true);
                    }}
                    itemDiscountBeforeVat={itemDiscountBeforeVat}
                    isFinalStep={currentStep === 3}
                    isLastItem={isLastItem}
                  />
                ) : currentStep === 1 ? (
                  <CartItemMobile
                    key={`${name}-${item?.product?.id}`}
                    cartItem={item}
                    lang={lang}
                    onRemoveProduct={onRemoveProductItem}
                    openNote={() => {
                      setPreviewProduct(item);
                      setIsOpenNoteModal(true);
                    }}
                    itemDiscountBeforeVat={itemDiscountBeforeVat}
                  />
                ) : (
                  <ConfirmedCartItemMobile
                    key={`${name}-${item?.product?.id}`}
                    cartItem={item}
                    lang={lang}
                    itemDiscountBeforeVat={itemDiscountBeforeVat}
                    isLastItem={isLastItem}
                  />
                );
              })}

              {showAccordion && (
                <ProductAccordionAction onClick={() => setIsProductListExpanded((prev) => !prev)}>
                  <ProductAccordionText>
                    {isProductListExpanded ? (
                      <FormattedMessage {...messages.collapseProducts} />
                    ) : (
                      <FormattedMessage
                        {...messages.seeMoreProducts}
                        values={{ count: validItems.length - COLLAPSED_PRODUCT_COUNT }}
                      />
                    )}
                  </ProductAccordionText>

                  <DownOutlined
                    style={{
                      fontSize: 10,
                      color: '#4B5563',
                      transform: isProductListExpanded ? 'rotate(180deg)' : undefined,
                    }}
                  />
                </ProductAccordionAction>
              )}

              {notAvailableProducts && notAvailableProducts.length > 0 && currentStep !== 3 && (
                <NotAvailableSectionWrapper>
                  <NotAvailableHeader>
                    <NotAvailableTitle>
                      <FormattedMessage {...messages.temporarilyOutOfStock} />
                    </NotAvailableTitle>

                    {onRemoveItem && (
                      <RemoveAllButton onClick={onRemoveAllNotAvailable}>
                        <FormattedMessage {...messages.removeCount} values={{ count: notAvailableProducts.length }} />
                      </RemoveAllButton>
                    )}
                  </NotAvailableHeader>

                  {notAvailableProducts.map((cartItem, index) => (
                    <NotAvailableProductItem
                      key={`notAvailableProduct-${index}`}
                      cartItem={cartItem}
                      lang={lang}
                      isDesktop={isDesktop}
                      onRemove={onRemoveItem ? onRemoveProductItem : undefined}
                    />
                  ))}
                </NotAvailableSectionWrapper>
              )}

              {currentStep !== 3 && (
                <AddMoreButtonWrapper>
                  <AddMoreButton to={loggedIn ? '/favorite' : '/'}>
                    {loggedIn ? <FavoriteIcon /> : <ShoppingBagIcon />}
                    <FormattedMessage
                      {...(loggedIn ? utilsMessages.addMoreFromFavorite : utilsMessages.buyMoreProducts)}
                    />
                  </AddMoreButton>
                </AddMoreButtonWrapper>
              )}
            </OrderTableWrapper>
          );
        }}
      </Viewport.Consumer>
      <ModalNote
        isOpen={isOpenNoteModal}
        confirmLoading={noteItemLoading}
        onSubmit={onNoteSubmit}
        onClose={onCloseNote}
        note={previewProduct?.product?.note || ''}
        productName={previewProduct?.product?.name || ''}
      />
    </>
  );
};

export default CheckoutOrderTable;
